var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840",
    transform: "translate(-427 -98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835",
    transform: "translate(427 98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ec008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M411.4,295.37l8.1-10.975a.382.382,0,0,0-.308-.608h-5.131a.382.382,0,0,1-.316-.6l4.776-7.068a.382.382,0,0,0-.317-.6h-5.943a.382.382,0,0,0-.36.252L408.1,286.3a.382.382,0,0,0,.359.511h4.307a.382.382,0,0,1,.365.5l-2.411,7.721A.382.382,0,0,0,411.4,295.37Z",
    transform: "translate(-397.681 -268.527)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/power-icon.3f65a17e594e65c1fbd15aa41e6d7a1b.svg";
export { ForwardRef as ReactComponent };